import { render, staticRenderFns } from "./AdditionalBarrelRecommendation.vue?vue&type=template&id=05f3acc8&scoped=true&"
import script from "./AdditionalBarrelRecommendation.vue?vue&type=script&lang=js&"
export * from "./AdditionalBarrelRecommendation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f3acc8",
  null
  
)

export default component.exports